import { render, staticRenderFns } from "./corporateTransfer.vue?vue&type=template&id=35a25f2e&scoped=true&"
import script from "./corporateTransfer.vue?vue&type=script&lang=js&"
export * from "./corporateTransfer.vue?vue&type=script&lang=js&"
import style0 from "./corporateTransfer.vue?vue&type=style&index=0&id=35a25f2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a25f2e",
  null
  
)

export default component.exports